import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar.js'
import VideoModal from '../ModalVideo/VideoModal'
import blogs from '../../api/blogs'

const ITEMS_PER_PAGE = 4;

const scrollToTop = () => {
    window.scrollTo(10, 0);
}

const BlogList = (props) => {
    const { keyword = '', danToc = '', loaiHoaTiet = '' } = props;
    // Lọc blogs theo search
    const filteredBlogs = blogs.filter(blog => {
        // Lọc theo keyword: chỉ tìm trong title, không phân biệt hoa thường, chỉ cần tiêu đề chứa chuỗi từ khóa
        const kw = keyword.trim().toLowerCase();
        let matchKeyword = true;
        if (kw) {
            matchKeyword = blog.title && blog.title.toLowerCase().includes(kw);
        }
        // Lọc theo danToc (hỗ trợ nhiều giá trị nếu có)
        let matchDanToc = true;
        if (danToc) {
            const blogDanTocArr = blog.danToc ? blog.danToc.split(',').map(s => s.trim()) : [];
            matchDanToc = blogDanTocArr.includes(danToc);
        }
        // Lọc theo loaiHoaTiet (hỗ trợ nhiều giá trị nếu có)
        let matchLoaiHoaTiet = true;
        if (loaiHoaTiet) {
            const blogLoaiArr = blog.loaiHoaTiet ? blog.loaiHoaTiet.split(',').map(s => s.trim()) : [];
            matchLoaiHoaTiet = blogLoaiArr.includes(loaiHoaTiet);
        }
        return matchKeyword && matchDanToc && matchLoaiHoaTiet;
    });

    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(filteredBlogs.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentBlogs = filteredBlogs.slice(startIndex, endIndex);

    // Reset về trang 1 khi filter thay đổi
    React.useEffect(() => { setCurrentPage(1); }, [keyword, danToc, loaiHoaTiet]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            scrollToTop();
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li key={i} className={currentPage === i ? 'active' : ''}>
                    <Link to="#" onClick={(e) => { e.preventDefault(); handlePageChange(i); }}>
                        {i}
                    </Link>
                </li>
            );
        }
        return pageNumbers;
    };
    return (
        <section className="wpo-blog-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="wpo-blog-content">
                            {currentBlogs.map((blog, bitem) => (
                                // Sử dụng blog.id làm key nếu nó duy nhất, nếu không dùng index (bitem)
                                <div className={`post ${blog.blClass || ''}`} key={blog.id || bitem}>
                                    <div className="entry-media video-holder">
                                        {/* Kiểm tra blogSingleImg tồn tại trước khi render */}
                                        {blog.blogSingleImg && <img src={blog.blogSingleImg} alt={blog.title || ''} />}
                                        {/* VideoModal có thể cần logic để hiển thị đúng video cho blog này */}
                                        {/* <VideoModal /> */}
                                    </div>
                                    <div className="entry-meta">
                                        <ul>
                                            {/* Đảm bảo blog.authorTitle hoặc blog.author tồn tại trong blogs.js */}
                                            <li><i className="fi flaticon-user"></i> Đăng bởi <Link onClick={scrollToTop} to={`/blog-single/${blog.slug}`}>{blog.authorTitle || blog.author || 'Admin'}</Link> </li>
                                            {/* <li><i className="fi flaticon-comment-white-oval-bubble"></i> Comments {blog.comment || 0}</li> */}
                                            <li><i className="fi flaticon-calendar"></i> {blog.create_at}</li>
                                        </ul>
                                    </div>
                                    <div className="entry-details">
                                        <h3><Link onClick={scrollToTop} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h3>
                                        {/* Hiển thị subtitle nếu có, nếu không thì dùng đoạn text mặc định */}
                                        <p>{blog.subtitle || "Law is a great career path if you want to build a broad skill set that includes everything from critical thinking and strategic planning to communications. If you love rising to a challenge."}</p>
                                        <Link onClick={scrollToTop} to={`/blog-single/${blog.slug}`} className="read-more">Chi tiết thêm...</Link>
                                    </div>
                                </div>
                            ))}

                            {totalPages > 1 && (
                                <div className="pagination-wrapper pagination-wrapper-left">
                                    <ul className="pg-pagination">
                                        <li>
                                            {/* Nút Previous */}
                                            <Link
                                                to="#"
                                                aria-label="Previous"
                                                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1); }}
                                                style={currentPage === 1 ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                                            >
                                                <i className="fi ti-angle-left"></i>
                                            </Link>
                                        </li>

                                        {renderPageNumbers()}

                                        <li>
                                            {/* Nút Next */}
                                            <Link
                                                to="#"
                                                aria-label="Next"
                                                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1); }}
                                                // Thêm class 'disabled' hoặc style để vô hiệu hóa khi ở trang cuối
                                                style={currentPage === totalPages ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                                            >
                                                <i className="fi ti-angle-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}

            
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>

    )

}

export default BlogList;
